import * as React from 'react'

import { createContext } from './Provider'

export default function useFilter<Value>() {
  const Context = createContext<Value>()
  const value = React.useContext(Context)

  if (!value) {
    throw new Error('useFilter must be used within a Filter.Wrapper')
  }

  return value
}
